var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6875 11.9817C21.6974 17.3192 17.3445 21.6837 12.007 21.6875C9.70176 21.6891 7.58426 20.8855 5.92023 19.5425C5.48754 19.1933 5.4552 18.5448 5.8484 18.1516L6.28852 17.7115C6.6248 17.3752 7.16168 17.3384 7.53426 17.634C8.76023 18.6068 10.3118 19.1875 12 19.1875C15.9729 19.1875 19.1875 15.9722 19.1875 12C19.1875 8.02715 15.9722 4.8125 12 4.8125C10.0932 4.8125 8.36137 5.55348 7.07547 6.76297L9.05805 8.74555C9.4518 9.1393 9.17293 9.8125 8.61613 9.8125H2.9375C2.5923 9.8125 2.3125 9.5327 2.3125 9.1875V3.50887C2.3125 2.95207 2.9857 2.6732 3.37945 3.06691L5.30805 4.99551C7.04723 3.33344 9.40438 2.3125 12 2.3125C17.3441 2.3125 21.6776 6.63984 21.6875 11.9817ZM14.6206 15.0592L15.0043 14.5658C15.3222 14.1571 15.2486 13.5681 14.8399 13.2502L13.25 12.0136V7.9375C13.25 7.41973 12.8303 7 12.3125 7H11.6875C11.1697 7 10.75 7.41973 10.75 7.9375V13.2364L13.305 15.2236C13.7137 15.5415 14.3027 15.4679 14.6206 15.0592V15.0592Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.c2a6caa0.svg";
export { ForwardRef as ReactComponent };